import { GlobalConfig } from '@eui/core';

export const GLOBAL: GlobalConfig = {
    appTitle: 'CSDR-app',
    i18n: {
        i18nService: {
            defaultLanguage: 'en',
            languages: ['bg', 'de', 'en', 'es', 'fr', 'it', 'nl', 'pl', 'pt', 'ro'],
        },
        i18nLoader: {
            i18nFolders: ['i18n-eui'],
            i18nResources: [
                {
                    prefix: 'backend/public/i18n/labels/',
                    suffix: '/',
                },
            ],
        },
    },
    user: {
        defaultUserPreferences: {
            dashboard: {},
            lang: 'en',
        },
    },
};
